const InstituteFeeData = {
    coursefee: "13,39,700",
    hostelfee: "4,36,800",
};
export default InstituteFeeData;
